import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import CactusProposalTemplate from "@/pages/CactusProposalTemplate";

export default function CactusProposal() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  
  const CORRECT_PASSWORD = "cactus2024";

  const handleAuthentication = () => {
    if (password === CORRECT_PASSWORD) {
      setIsAuthenticated(true);
      setErrorMessage("");
      // Store authentication in session storage to persist during page refreshes
      sessionStorage.setItem("cactus-authenticated", "true");
    } else {
      setErrorMessage("Incorrect password. Please try again.");
    }
  };

  // Check session storage for authentication on component mount
  useEffect(() => {
    const storedAuth = sessionStorage.getItem("cactus-authenticated");
    if (storedAuth === "true") {
      setIsAuthenticated(true);
    }
  }, []);

  // Password entry handler for Enter key
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleAuthentication();
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="flex flex-col min-h-screen">
        <Navbar />
        
        <main className="flex-grow flex items-center justify-center p-6 bg-gray-50">
          <div className="bg-white p-8 rounded-sm shadow-md max-w-md w-full border border-gray-100">
            <h1 className="text-2xl font-serif font-medium text-indigo-950 mb-6 text-center">
              Cactus Proposal
            </h1>
            <p className="text-sm text-gray-700 mb-6 text-center">
              This document is password protected. Please enter the password to continue.
            </p>
            
            <div className="mb-4">
              <Input 
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={handleKeyPress}
                className="w-full p-2 border border-gray-300 rounded-sm"
              />
              {errorMessage && (
                <p className="text-red-500 text-xs mt-2">{errorMessage}</p>
              )}
            </div>
            
            <Button
              onClick={handleAuthentication}
              className="w-full bg-indigo-950 hover:bg-indigo-900 text-white py-2 rounded-sm text-sm"
            >
              Access Document
            </Button>
          </div>
        </main>
        
        <Footer />
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      
      <main className="flex-grow p-6">
        <div className="mb-8 max-w-6xl mx-auto">
          <h1 className="text-2xl font-serif font-medium text-indigo-950 mb-4">Cactus x NGM Proposal</h1>
          <p className="text-sm text-gray-700 mb-6">Clinical Product Strategy for the Institute for Healthier Living (IHL), Abu Dhabi</p>
          
          <div className="border border-gray-200 shadow-sm mx-auto max-w-4xl">
            <div className="bg-white" style={{ width: "794px" }}>
              <CactusProposalTemplate />
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}